// https://vuex.vuejs.org/en/state.html

export default {
  initialLoad: false,
  loader: {
    loading: false,
    text: 'Loading'
  },
  formDialogSaving: false,
  formDialogSuccess: false,
  snackbar: {
    show: false,
    type: 'info',
    message: '',
    timeout: 5000,
    buttons: false,
    onClickYes: null,
    oneButton: false,
    oneButtonLabel: 'Click Here',
    onOneButtonClick: null
  },
  dialog: {
    show: false,
    type: 'alert',
    persistent: false,
    title: '',
    description: '',
    yesLabel: 'Yes',
    noLabel: 'No',
    yesHandler: null,
    yesHandlerLoading: false,
    noHandler: null,
    linkLabel: '',
    linkHandler: null
  },
  formDialog: {
    show: false,
    type: 'new', // new, edit
    persistent: true,
    title: null,
    fields: { // TODO: for reusability, this shouldnt be hardcoded, should be array
      Acct_ID: null,
      // OB_ID: null,
      Acct_name: null,
      Acct_DL: null,
      Date_onboarded: null,
      Last_Date_Validated: null,
      Date_Suspended: null,
      Date_Requested_change: null,
      MP_ID: null,
      Previous_MP_ID: null,
      Managed_Svc: null,
      Acct_status: 'New',
      AWS_Support_Type: null,
      Is_MP: 0,
      Acct_Description: null,
      GovCloud_Resource_Account: null
    },
    saveLabel: 'Save',
    cancelLabel: 'Cancel',
    saveHandler: null,
    saveHandlerLoading: false,
    cancelHandler: null,
    saving: false,
    saved: false,
    alertType: 'success', // success, error
    alertMessage: ''
  },
  serverErrorDialog: {
    show: false,
    error: 'The application encountered unexpected error and preventing it from completing the request. An email was sent to Galaxy Technical Team to assess the issue. Alternatively, please close the browser or retry by refreshing the page. Browsers sometimes try to "remember" certain pages in order to load them quickly.'
  },
  currentUser: {
    isLoggedIn: false,
    view: '',
    contact_id: '',
    name: '',
    email: '',
    family_name: '',
    given_name: '',
    groups: [],
    requestor_id: []
  },
  viewCustomFields: {
    isAllowed: false
  },
  lastSyncDate: null,
  logRecord: {
    id: null,
    action: null,
    module: null,
    changeFrom: null,
    changeTo: null
  },
  changeLog: {
    show: false,
    id: '',
    action: 'all',
    module: 'all',
    loading: false,
    headers: [
      {
        sortable: true,
        text: 'ID',
        value: 'Log_Id',
        align: 'left'
      },
      {
        sortable: true,
        text: 'Action',
        value: 'action',
        align: 'left'
      },
      {
        sortable: true,
        text: 'User',
        value: 'User',
        align: 'left'
      },
      {
        sortable: true,
        text: 'Change From',
        value: 'Change_From',
        align: 'left'
      },
      {
        sortable: true,
        text: 'Change To',
        value: 'Change_To',
        align: 'left'
      },
      {
        sortable: true,
        text: 'Created At',
        value: 'Create_Date',
        align: 'left'
      }
    ],
    startDate: null,
    endDate: null,
    highlight: false,
    data: []
  }
}
